module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/auth/lock/lock.component.scss
// module id = ./src/app/routes/auth/lock/lock.component.scss
// module chunks = main